<div class="notification">
  <div class="toggle-btn" [class.toggled]="toggleNotificationSidebar" [matBadgeHidden]="notificationsCount === 0"
    [matBadge]="notificationsCount.toString()" matBadgeColor="warn" matBadgeSize="small">
    <img id="bell" src="../../../assets/icons/notification/bell.svg" (click)="toggleDrawer()"
      (keydown.enter)="toggleDrawer()" (keydown.space)="toggleDrawer()" alt="Notificaciones" aria-label="Notificaciones" title="Notificaciones" role="button"
      tabindex="0" />
    </div>

    <mat-drawer-container class="indu-sidenav" autosize>
      <mat-drawer #notificationDrawer class="indu-sidenav-notification sidenav-fixed" mode="over" [position]="'end'"
        [opened]="toggleNotificationSidebar" (closedEnd)="toggleNotificationSidebar = false"
        (closedStart)="toggleNotificationSidebar = false">
        <div class="sticky-header">
          <div class="notification-header row pt-3 pb-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h3 class="mb-0">Notificaciones</h3>
              </div>
              <div style="margin-right: 15px;">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Opciones de notificaciones" title="Opciones de notificaciones">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item [class.disabled]="notificationsCount == 0"
                    (click)="notificationsCount > 0 && markAllAsRead()"
                  (keydown)="notificationsCount > 0 && markAllAsRead()" tabindex="-1">Marcar todas como leídas</button>
                  <button mat-menu-item (click)="goToNotificationCenter()">Ir a Centro de Notificaciones</button>
                </mat-menu>
              </div>
            </div>
          </div>

          <div class="row pt-3 pb-3 notification-header">
            <div class="col-4">
              @if (notificationsCount > 0) {
<span class="unread-label" [attr.aria-label]="
                notificationsCount + ' notificaciones no leídas'
              ">
                  {{ notificationsCount }} {{ notificationsCount > 1 ? 'no leídas' : 'no leída' }}
                </span>
              }
            </div>
            <div class="col-8 text-end">
              <mat-slide-toggle class="pe-3" [(ngModel)]="isChecked" (change)="showOnlyUnread($event)"
                labelPosition="before" aria-label="Mostrar solo las no leídas">
                Mostrar solo las no leídas
              </mat-slide-toggle>
            </div>
          </div>
        </div>

        @if (notificationsList.length === 0) {
          <div class="no-notifications-message m-auto" role="status"
            aria-live="polite">
            @if (isChecked) {
              No tienes notificaciones sin leer
            } @else {
              No tienes notificaciones
            }
          </div>
        }

        @for (notification of notificationsList; track trackByNotificationId($index, notification)) {
          <div class="row m-2 justify-content-center pt-1 notification-mat-card"
            role="listitem">
            <div class="col-1">
              <div class="img-frame">
            <span class="unread-icon" [ngClass]="
                notification.status == 2
                  ? 'unread-icon-background'
                  : 'read-icon-background'
              " (click)="markNotification(notification.id)" [attr.aria-label]="
                notification.status === 2 ? 'Marcar como leída' : 'Marcar como no leída'
              " [attr.title]="
                notification.status === 2 ? 'Marcar como leída' : 'Marcar como no leída'
              " (keydown)="markNotification(notification.id)" tabindex="-1"></span>
                <div class="icon-notification" aria-hidden="true">i</div>
              </div>
            </div>
            <div class="info-container col-10">
              <mat-card appearance="outlined" [attr.aria-label]="'Notificación: ' + notification.title">
                <mat-card-header class="notifcation-title ml-0">
                  <mat-card-title>{{ notification.title }}</mat-card-title>
                  <mat-card-subtitle>{{ notification.description }}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  @if (notification.type == 10) {
<a class="nuevoPrestador" (click)="
                  goSupplierDetail(notification.extraInfo.contractorId);
                  toggleDrawer();
                  markNotification(notification.id)
                ">
                    Ver perfil del nuevo prestador</a>
                  }
                  @if (
                    notification.type == 13 ||
                    notification.type == 14 ||
                    notification.type == 15
                    ) {
<a class="nuevoPrestador" (click)="
                  goToOADetails(notification.extraInfo.assemblyOrderId);
                  toggleDrawer();
                  markNotification(notification.id)
                ">
                    Ver Orden de Montaje modificada</a>
                  }
                  @if (notification.type == 1 || notification.type == 17) {
<a class="nuevoPrestador" (click)="
                  goToTaskDetails(notification.extraInfo.taskId);
                  toggleDrawer();
                  markNotification(notification.id)
                ">
                    Ver detalle de tarea</a>
                  }
                  @if (notification.type == 16) {
<a class="nuevoPrestador" (click)="
                  goToSapArticleDetails(
                    notification.extraInfo.manufacturingItemId
                  );
                  toggleDrawer();
                  markNotification(notification.id)
                ">
                    Ver nuevo articulo SAP</a>
                  }
                  @if (notification.type == 23) {
<a class="nuevoPrestador" (click)="
                  goToBudget(notification.extraInfo.budgetId);
                  toggleDrawer();
                  markNotification(notification.id)
                ">
                    Ver presupuesto</a>
                  }
                  <p class="mt-2 notifcation-date">
                    {{ notification.sentDate | date : "dd/MM/yyyy HH:mm" }}
                  </p>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        }

        <div class="notification-footer">
          <mat-card-subtitle>
            Estas son todas tus notificaciones de los últimos 7 días.
          </mat-card-subtitle>
          <mat-card-subtitle>
            Para ver el historial completo, dirígete al
            <a href="javascript:void(0)" (click)="goToNotificationCenter()" tabindex="0">
              centro de notificaciones.
            </a>
          </mat-card-subtitle>
        </div>
      </mat-drawer>
    </mat-drawer-container>
  </div>